<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面談日期</label>
              <el-date-picker
                style="width: 100%"
                v-model="search.RangeDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
              >
                >
              </el-date-picker>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">時段</label>
              <el-select
                style="display: block"
                v-model="search.TimePeriod"
                placeholder="請選擇"
                filterable
                clearable
              >
                <el-option
                  :key="option.Value"
                  :label="option.Text"
                  v-for="option in timePeriodOptions"
                  :value="option.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">報到情形</label>
              <el-select
                style="width: 100%"
                v-model="search.CheckInStatus"
                multiple
                filterable
                clearable
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in checkInStatusOptions"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">應徵職務</label>
              <el-select
                style="width: 100%"
                v-model="search.ManpowerDemandNo"
                filterable
                clearable
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in positionOptions"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">招募窗口</label>
              <el-select
                style="width: 100%"
                filterable
                clearable
                collapse-tags
                multiple
                v-model="search.ContactPersonGuid"
                placeholder="請選擇窗口"
              >
                <el-option
                  v-for="item in contactOptions"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面試狀態</label>
              <el-select
                style="width: 100%"
                v-model="search.InterviewStatus"
                filterable
                clearable
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in interviewStatusOptions"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">姓名</label>
              <input
                type="text"
                id="search-name"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.NameKeyword"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <button
              @click="getFlowOverview()"
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
            >
              {{ i18n("Buttons.Search") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="
                search = {
                  RangeDate: search.RangeDate,
                }
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="text-right">
      更新時間:{{ reloadTime }}
    </div>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload" />
    </div>
    <div class="text-right">
      <span style="position: relative; bottom: -30px"
        >共計{{ rows.length }}人</span
      >
    </div>
    <el-tabs v-model="activeName" @tab-click="getFlowOverview">
      <el-tab-pane label="全部" name="All"> </el-tab-pane>
      <el-tab-pane label="IDL" name="IDL"> </el-tab-pane>
      <el-tab-pane label="DL" name="DL"></el-tab-pane>
    </el-tabs>

    <div class="yahome-table-wrap">
      <el-table
        :data="rows"
        style="width: 100%"
        height="400px"
        :default-sort="{ prop: 'CheckInType', order: 'descending' }"
      >
        <el-table-column
          label="類型"
          fixed="left"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'CheckInType')"
        >
          <template slot-scope="props">
            <span v-if="props.row.CheckInType === 1">預約到廠</span>
            <span v-if="props.row.CheckInType === 2">臨時到廠</span>
            <span></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Name"
          label="應徵者姓名"
          width="180"
          fixed="left"
          sortable
        >
          <template slot-scope="props">
            <span
              class="name-link"
              :class="{
                female: props.row.Sex === '女',
                male: props.row.Sex === '男',
              }"
              @click="showDetailModal(props.row)"
              >{{ props.row.Name }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="MobilePhone"
          label="手機號碼"
          width="120"
          fixed="left"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'MobilePhone')"
        >
        </el-table-column>
        <el-table-column
          prop="IdNo"
          label="身分證字號"
          width="120"
          fixed="left"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'IdNo')"
        >
        </el-table-column>
        <el-table-column
          prop="Sex"
          label="性別"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'Sex')"
        ></el-table-column>
        <el-table-column
          prop="ManpowerDemandName"
          label="應徵職務"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="報到情形"
          width="120"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'Status')"
        >
          <template slot-scope="props">
            <span v-if="props.row.Status === 1">改期</span>
            <span v-if="props.row.Status === 2">取消</span>
            <span v-if="props.row.Status === 3">未報到</span>
            <span v-if="props.row.Status === 4">已報到</span>
            <span v-if="props.row.Status === 5">已報到</span>
            <span v-if="props.row.Status === 6">已報到</span>
          </template>
        </el-table-column>

        <el-table-column prop="window" width="150" label="招募窗口">
          <template slot-scope="props">
            <el-select
              @change="saveContact($event, props.row.ArrangeGuid)"
              style="width: 100%"
              filterable
              v-model="props.row.ContactPersonGuid"
              placeholder="請選擇窗口"
            >
              <el-option
                v-for="item in contactOptions"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="面談流程" width="150">
          <template slot-scope="props">
            <el-select
              filterable
              @change="saveFlow($event, props.row.ArrangeGuid)"
              style="width: 100%"
              v-model="props.row.BaseFlowGuid"
              placeholder="請選擇流程"
            >
              <el-option
                v-for="item in flowOptions"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
                :disabled="!item.IsEnabled"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="StageName"
          label="目前進度"
          width="120"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'StageName')"
        >
        </el-table-column>
        <el-table-column
          prop="RoomName"
          label="面談室"
          width="120"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'RoomName')"
        >
        </el-table-column>
        <el-table-column
          label="面談日期"
          width="150"
          prop="InvitationTime"
          :formatter="dateFormatter"
          sortable
        ></el-table-column>
        <el-table-column
          prop="StageStartTime"
          label="開始時間"
          width="120"
          :formatter="timeMoment"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'StageStartTime')"
        ></el-table-column>
        <el-table-column
          prop="StageEndTime"
          label="結束時間"
          width="120"
          :formatter="timeMoment"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'StageEndTime')"
        ></el-table-column>
        <el-table-column
          prop="StageExpectEndTime"
          label="預定結束時間"
          width="150"
          :formatter="timeMoment"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'StageExpectEndTime')"
        ></el-table-column>
        <el-table-column
          label="狀態"
          width="150"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'ExpireStatus')"
        >
          <template slot-scope="props">
            <el-tag
              v-for="(item, index) in props.row.ExpireStatus"
              :key="index"
              :type="
                item === '超時' || item === '整體流程超時'
                  ? 'danger'
                  : 'warning'
              "
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 報到 Modal -->
    <div class="modal fade" id="scanModal" tabindex="-1" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">報到</h5>
          </div>
          <div class="modal-body text-center">
            <img src="@/assets/img/demo.png" alt="" />
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 未到 Modal -->
    <div
      class="modal fade"
      id="arrivalModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">未到</h5>
          </div>
          <div class="modal-body">
            <div class="p-card">
              <div class="person-info">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEGnM5D_MDXz_E_p6vw23_wSS5G6gWD7ToOg&usqp=CAU"
                  alt=""
                />
                <div class="info">
                  <div class="name">{{ person.name }}</div>
                  <div class="id">{{ person.id }}</div>
                  <div class="job">{{ person.job }}</div>
                </div>
              </div>
              <div class="job-info">
                <span>
                  <div class="svg-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"
                      />
                    </svg>
                  </div>

                  <span>2022/10/31 10:00</span>
                </span>

                <span>
                  <div class="svg-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                      />
                    </svg>
                  </div>
                  <el-input
                    placeholder="請輸入未到原因"
                    v-model="person.textarea"
                  >
                  </el-input>
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
            <button type="reset" class="btn btn-primary" data-dismiss="modal">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 改期 Modal -->
    <div
      class="modal fade"
      id="rescheduleModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">改期</h5>
          </div>
          <div class="modal-body">
            <div class="p-card">
              <div class="person-info">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEGnM5D_MDXz_E_p6vw23_wSS5G6gWD7ToOg&usqp=CAU"
                  alt=""
                />
                <div class="info">
                  <div class="name">{{ person.name }}</div>
                  <div class="id">{{ person.id }}</div>
                  <div class="job">{{ person.job }}</div>
                </div>
              </div>
              <div class="job-info">
                <span>
                  <div class="svg-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M232 120C232 106.7 242.7 96 256 96C269.3 96 280 106.7 280 120V243.2L365.3 300C376.3 307.4 379.3 322.3 371.1 333.3C364.6 344.3 349.7 347.3 338.7 339.1L242.7 275.1C236 271.5 232 264 232 255.1L232 120zM256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0zM48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48C141.1 48 48 141.1 48 256z"
                      />
                    </svg>
                  </div>

                  <span>2022/10/31 10:00</span>
                </span>

                <span>
                  <div class="svg-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                      />
                    </svg>
                  </div>
                  <el-input
                    placeholder="請輸入改期原因"
                    v-model="person.textarea"
                  >
                  </el-input>
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              關閉
            </button>
            <button type="reset" class="btn btn-primary" data-dismiss="modal">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a>
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>

            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar class="page">
                <section class="page-inner">
                  <div class="title">
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="
                          $common.downloadResumePDF(
                            resumeDetail.ResumeType,
                            resumeDetail.ResumeId
                          )
                        "
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="resumeDetail.ResumeType === 'IDL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'IDL'"
                  />
                  <DlResume
                    v-if="resumeDetail.ResumeType === 'DL'"
                    :ResumeId="resumeDetail.ResumeId"
                    :ResumeType="'DL'"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { mapGetters } from "vuex";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

export default {
  name: "RoomScheduleSetting",

  components: {
    IdlResume,
    DlResume,
  },
  data() {
    return {
      reloadTime: null, //重新刷新的時間
      timePeriodOptions: [],
      checkInStatusOptions: [],
      positionOptions: [],
      contactOptions: [],
      interviewStatusOptions: [],
      flowOptions: [],

      resumeDetail: {},
      isShowDetail: false,
      activeName: "All",

      search: {
        RangeDate: [new Date(), new Date()],
      },
      rows: [],
      startPickerOptions: {
        disabledDate: null,
      },
      endPickerOptions: {
        disabledDate: null,
      },

      person: {
        textarea: null,
      },
    };
  },
  watch: {
    "search.StartDate": function () {
      const startDate = this.search.StartDate;
      let days = this.dayjs(this.search.StartDate);

      if (startDate) {
        this.endPickerOptions = {
          disabledDate(date) {
            return date < days;
          },
        };
      }
    },
    "search.EndDate": function () {
      const endDate = this.search.EndDate;
      let days = this.dayjs(this.search.EndDate);

      if (endDate) {
        this.startPickerOptions = {
          disabledDate(date) {
            return date > days;
          },
        };
      }
    },
  },

  methods: {
    getCheckInStatus() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getCheckInStatus()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.checkInStatusOptions = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
    getInterviewStatus() {
      const vm = this;

      vm.$store.dispatch("updateLoading", false);
      vm.$api.InterviewSch.getInterviewStatus()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.interviewStatusOptions = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },
    getPosition() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getPosition()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.positionOptions = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getFlowOptions() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getFlowOptions()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.flowOptions = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getContactOptions() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getContactOptions()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.contactOptions = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getTimePeriodOptions() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getTimePeriodOptions()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.timePeriodOptions = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getFlowOverview() {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      let params = {
        ...vm.search,
        ResumeType: null,
        StartDate: vm.search.RangeDate ? vm.search.RangeDate[0] : null,
        EndDate: vm.search.RangeDate ? vm.search.RangeDate[1] : null,
      };
      if (vm.activeName === "IDL") {
        params.ResumeType = 1;
      } else if (vm.activeName === "DL") {
        params.ResumeType = 0;
      }

      vm.$api.InterviewSch.getFlowOverview(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.rows = response.data.Data;
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    saveFlow(val, guid) {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      let params = {
        arrangeGuid: guid,
        baseFlowGuid: val,
      };
      vm.$api.InterviewSch.setOverviewFlow(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    saveContact(val, guid) {
      const vm = this;

      vm.$store.dispatch("updateLoading", true);
      let params = {
        arrangeGuid: guid,
        contactPersonGuid: val,
      };
      vm.$api.InterviewSch.setOverviewContact(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            this.$notify({
              message: response.data.Data,
              type: "success",
            });
          }

          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    reload() {
      //重新讀取
      const today = new Date();
      const hour = today.getHours();
      const min = today.getMinutes();
      const sec = today.getSeconds();

      // 轉成字串，如果低於10，前面加上'0'
      const hourString = hour < 10 ? "0" + hour : "" + hour;
      const minString = min < 10 ? "0" + min : "" + min;
      const secString = sec < 10 ? "0" + sec : "" + sec;

      this.reloadTime = hourString + ":" + minString + ":" + secString;
      this.getFlowOverview();
    },
    // 檢視履歷
    showDetailModal(person) {
      const vm = this;
      vm.resumeDetail = {
        ResumeType: person.ResumeType,
        ResumeId: person.ResumeId,
      };
      this.isShowDetail = true;
    },
    openScanModal() {
      $("#scanModal").modal("show");
    },

    openArrivalModal(row) {
      this.person = { ...row };
      $("#arrivalModal").modal("show");
    },

    openRescheduleModal(row) {
      this.person = { ...row };
      $("#rescheduleModal").modal("show");
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    dateFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    timeMoment(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("HH:mm");
      } else {
        return "";
      }
    },

    defaultSort(a, b, prop) {
      if (a[prop] === null) {
        return 1;
      } else {
        return a[prop] < b[prop] ? 1 : -1;
      }
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },
  },

  created() {
    this.getFlowOverview();
    this.getCheckInStatus();
    this.getInterviewStatus();
    this.getPosition();
    this.getFlowOptions();
    this.getContactOptions();
    this.getTimePeriodOptions();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.name-link {
  background-color: #f8f2a0;
  padding: 3px 15px;
  border-radius: 25px;
  display: inline-block;
  cursor: pointer;
  &.female {
    background-color: #ffd4d4;
  }
  &.male {
    background-color: #d9e3ff;
  }
}
.p-card {
  background-color: #fff;
  overflow: hidden;
  border-radius: 6px;

  margin: 10px;
  .person-info {
    display: flex;
    padding: 20px;
    position: relative;
    z-index: 2;
    margin-bottom: -20px;
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 5px 5px 0 rgba(#000, 0.15);
      margin-right: 15px;
    }
    .info {
      flex: 1;
      .name {
        font-size: 1.5em;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .id {
        font-size: 0.8em;
      }
      .job {
        background-color: #5380f7;
        color: #fff;
        padding: 3px 15px;
        font-size: 0.8em;
        margin-top: 17px;
        border-radius: 25px;
        display: inline-block;
      }
    }
  }
  .job-info {
    background-color: #d9e3ff;
    padding: 20px;
    position: relative;
    &::after {
      content: "";
      width: 200%;
      height: 100px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: #d9e3ff;
      transform: rotate(-7deg);
      transform-origin: top left;
    }
    span {
      background-color: #fff;
      border-radius: 25px;
      padding: 3px 5px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .svg-wrap {
        background-color: #5380f7;
        margin-right: 5px;
        border-radius: 50%;
        padding: 5px;
        width: 30px;
        height: 30px;
        svg {
          width: 100%;
          height: 100%;
          fill: #fff;
          position: relative;
          top: -4px;
        }
      }
      position: relative;
      z-index: 2;
      /deep/ .el-input__inner {
        border: none !important;
      }
    }
  }
}
</style>
